<template>
	
	 <article>
	  <figure class="img img-sq">
	   <prismic-link :field="article.article_link">
	   	<img v-lazy="article.article_thumbnail.url" />
        <figcaption><prismic-rich-text :field="article.thumbnail_caption"/></figcaption>
	    </prismic-link>
	  </figure>
	  <aside class="wrap wrap-half">
	      <div class="bt text-larger">
		        <span v-if="article.article_link.tags.includes('reports')" class="text-uppercase text-condensed">Performa Reports</span>
				    <span v-if="article.article_link.tags.includes('in-conversation')" class="text-uppercase text-condensed">In Conversation</span>
				    <span v-if="article.article_link.tags.includes('features')" class="text-uppercase text-condensed">Features</span>
				    <span v-if="article.article_link.tags.includes('essays')" class="text-uppercase text-condensed">Essays</span>
	          <h4 class="text-extended text-larger"><strong>{{ article.article_title }}</strong></h4>
	          <prismic-rich-text :field="article.article_excerpt"/>
	          <prismic-link :field="article.article_link" class="btn">
		          <span><strong>{{ article.cta_text }}</strong></span>
	          </prismic-link>
	      </div>
	  </aside>
  </article>
  
</template>

<script>
import moment from 'moment'

export default {
  name: 'FeaturedArticle',
  props: ['article'],
  data () {
    return {
    }
  },
	methods: {
		labelFormat(date) {
			var label = moment(date);
			label = label.format('ddd MMM D');
			return label;
		},
		timeFormat(datetime) {
			var label = moment(datetime);
			label = label.format('H:mma');
			return label;
		}
	},
	created () {
  }
}
</script>